<template>
  <div class="ctas" role="menu" aria-label="CTA menu">
    <router-link
      v-if="menu_links.link_home.is_active"
      :to="{name: 'Home'}"
      tag="a"
      class="cta home-btn"
      role="menuitem"
      aria-label="Home"
    >
      <i aria-hidden="true" class="material-icons">{{ menu_links.link_home.icon }}</i>
      <span>{{ $tr(menu_links.link_home.link) }}</span>
    </router-link>
    <a
      v-if="menu_links.link_admissions.is_active"
      :href="menu_links.link_admissions.link.href"
      class="cta"
      target="_blank"
      role="menuitem"
    >
      <i aria-hidden="true" class="material-icons">{{ menu_links.link_admissions.icon }}</i>
      <span>{{ $tr(menu_links.link_admissions.link.name) }}</span>
    </a>
    <a
      v-if="menu_links.link_request_info.is_active"
      :href="menu_links.link_request_info.link.href"
      class="cta"
      target="_blank"
      role="menuitem"
    >
      <i aria-hidden="true" class="material-icons">{{ menu_links.link_request_info.icon }}</i>
      <span>{{ $tr(menu_links.link_request_info.link.name) }}</span>
    </a>
    <a
      v-if="menu_links.link_apply.is_active"
      :href="menu_links.link_apply.link.href"
      class="cta"
      target="_blank"
      role="menuitem"
    >
      <i aria-hidden="true" class="material-icons">{{ menu_links.link_apply.icon }}</i>
      <span>{{ $tr(menu_links.link_apply.link.name) }}</span>
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CTAs',
  computed: {
    ...mapState({
      menu_links: state => state.college.settings.menu_links
    })
  }
}
</script>
